//Testimonials Swiper
$(".swiper-slider").each(function () {
  var $swiperContainer = $(this);
  var swiper = new Swiper(this, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
      },
      992: {
        slidesPerView: 1.8,
      },
      1440: {
        slidesPerView: 2.2,
      },
    },
  });


});
